export enum ReservationType {
  Buffet = 'buffet',
  PizzaTable = 'PizzaTable',
  BuffetWorld = 'BuffetWorld',
  GroupDiningOther = '',
}

export type Reservation = {
  id: string
  startTime: string
  endTime: string
  name: string
  peopleCount: number
  otherInfo: string
  room: string
  contactName: string
  contactPhone: string
  paymentMethod: string
  reservationType: ReservationType
  mealOptionId: number
  mealOptionDescription: string
}

export type MealOption = {
  id: number
  name: string
  description: string
}
